module.exports = __webpack_public_path__ + "static/media/zip-file.5bfc49df.svg";